<template>
    <div id="itemGrid">
        <b-input-group size="sm" class="py-2">
            <b-input-group-prepend :is-text="true">
                <b-icon icon="search"></b-icon>
            </b-input-group-prepend>
            <b-form-input 
                v-model="searchTerm"
                type="search" 
                name="search" 
                autocomplete="off" 
                :placeholder="$t('g_Recherche')" 
            >
            </b-form-input>
        </b-input-group>

        <table class="table table-bordered align-items-center table-sm">
            <thead class="thead-light">
                <tr>
                    <td v-for="(col, index) in getFilters" :key="index">
                        <div class="d-flex justify-content-around">

                            <div class="d-inline-flex p-1">
                                <div class="p-1">
                                    <div class="d-flex flex-column justify-content-center align-items-center">
                                        <span v-text="col.label"></span>
                                        <b-form-input v-if="currrentFilterIndex == index" size="sm" class="mx-2" autocomplete="off" ref="productSearch" id="search" name="search" type="text" :placeholder="$t('g_Recherche')" 
                                            v-model="searchTxt" 
                                            v-on:keyup="filterProduct(col.field)" 
                                        />
                                    </div>
                                </div>
                                <div class="p-0 d-flex align-items-end">
                                    <span class="m-2 cursorPoint align-middle" v-if="currrentFilterIndex != index" v-on:click="activateFilter(index,col.field)" ><i class="bi bi-funnel"></i></span>
                                    <span class="m-2 cursorPoint align-middle" v-if="currrentFilterIndex == index" v-on:click="clearFliter" ><i class="bi bi-x-lg"></i></span>
                                </div>
                            </div>
                            
                        </div>
                    </td>
                </tr>
            </thead>
            <tbody v-if="resultList.length > 0">
                <tr>
                    <td :colspan="getFilters.length">
                        <div v-if="resultList.length > 0"  class="row mx-auto d-flex flex-row flex-wrap" style="max-height:100px; overflow-y:auto;">
                            <div v-for="(item, index) in resultList" :key="index"
                                class="cursorPoint p-1 m-1 border badge badge-light text-wrap text-center text-justify filter" 
                                v-on:click="applyFilter(item)" 
                            >
                                <div class="">
                                    <span v-text="item.label" ></span><br/>
                                </div>
                            </div>
                        </div>
                        <div v-else class="d-flex justify-content-center align-items-center">
                            <span v-if="currrentFilterIndex != -1 ">Aucun élément trouvé</span>
                        </div>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                
            </tfoot>
        </table>

        <div style="margin-top:-14px;">
            <vue-good-table
                @on-row-click="selectRow"
                @on-row-dblclick="onRowDoubleClick"
                @on-cell-click="selectCell"
                @on-row-mouseenter="onRowMouseover"
                @on-row-mouseleave="onRowMouseleave"
                @on-selected-rows-change="selectionChanged"
                :columns="columns"
                :rows="filteredRows" 
                max-height="400px"
                :row-style-class="rowStyleClassFn"
                :fixed-header="true"
                :search-options="{ enabled: true, placeholder: $t('g_Recherche'),externalQuery: searchTerm}"
                :select-options="{
                    enabled: isSelectOptions,
                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                    //selectionInfoClass: 'custom-class',
                    selectionText: $t('g_ItemsRowsSelected'),
                    clearSelectionText: $t('g_Efface'),
                    //disableSelectInfo: true, // disable the select info panel on top
                    selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
                }"
                :pagination-options="{ 
                    enabled: this.isPagination, 
                    perPage: 10 , 
                    perPageDropdown: [5, 10, 20, 50, 100, 200, 400],
                    firstLabel : 'Première page',
                    lastLabel : 'Dernière page',
                    nextLabel: 'suivant',
                    prevLabel: 'précédent',
                    rowsPerPageLabel: 'Lignes par page',
                    ofLabel: 'de',
                    allLabel: 'Tous',
                }"
                :compactMode="false" 
                >

                <!-- SLOT des colonnes -->
                <template slot="table-column" slot-scope="props">
                    {{ props.column.label }} 
                </template>
                <!-- FIN - SLOT des colonnes -->

                <!-- SLOT des lignes -->
                <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.type.name === 'monetary'">
                        {{ getMonetaryValue(props.formattedRow[props.column.field]) }}
                    </span>
                    <span v-else-if="props.column.type.name === 'quantity'">
                        {{ getQuantityValue(props.formattedRow[props.column.field])}}
                    </span>
                    <span v-else-if="props.column.type.name === 'longtext'">
                        {{props.formattedRow[props.column.field]}}
                    </span>
                    <span v-else-if="props.column.type.name === 'boolean'">
                        <span v-if="props.formattedRow[props.column.field]"> {{$t("g_Oui")}}</span>
                        <span v-else >  {{$t("g_Non")}}</span>
                    </span>
                    <span v-else-if="props.column.type.name === 'date'">
                        <span>{{ showDate(props.formattedRow[props.column.field]) }}</span>
                    </span>
                    <span v-else-if="props.column.field == 'action'">
                        <span class="rowStyle text-nowrap">
                            <b-icon icon="pencil-square" :variant="getTheme.warning" font-scale="1" class="txtMain mr-1" @click="editRow(props.row, props.index)"></b-icon>
                            <b-icon icon="trash" :variant="getTheme.danger" font-scale="1" class="txtMain mx-1" @click="deleteRow(props.index)"></b-icon>
                        </span>
                    </span>
                    <span v-else>{{props.formattedRow[props.column.field]}}</span>
                </template>
                <!-- FIN - SLOT des lignes -->

                <!-- <div slot="selected-row-actions">
                    <b-button :variant="getTheme.warning" size="sm" class="mr-2 mb-2" >
                        <b-icon icon="check-lg" :variant="getTheme.light" font-scale="1" class="mr-0"></b-icon> 
                        <span class=""><small>Action 1</small></span>
                    </b-button>
                </div> -->

                <div slot="table-actions">
                    <b-button v-show="isAddItemBtn" :variant="getTheme.warning" size="sm" class="mr-2 mb-2" @click="addItem()">
                        <b-icon icon="plus" :variant="getTheme.light" font-scale="1" class="mr-0"></b-icon> 
                        <span class=""><small>{{ labelAdd }}</small></span>
                    </b-button>
                    <b-button  :variant="getTheme.warning" size="sm" class="mr-1 mb-2" @click="openMenu=!openMenu">
                        <b-icon icon="gear" :variant="getTheme.light" font-scale="1"></b-icon> 
                        <span class=""><small></small></span>
                    </b-button>

                    <b-button  :variant="getTheme.warning" size="sm" class="mr-1 mb-2" @click="enableMultipleSelection">
                        <b-icon icon="toggles" :variant="getTheme.light" font-scale="1"></b-icon>
                    </b-button>

                    <b-button  :variant="getTheme.warning" size="sm" class="mr-1 mb-2" @click="enablePagination">
                        <b-icon icon="list-ol" :variant="getTheme.light" font-scale="1"></b-icon>
                    </b-button>

                    <!--SELECTION DES COLONNES - MENU NON VISIBLE SANS LE CLIQUE SUR LE BOUTON MENU-->
                    <div class="columnSelectionRelative" v-show="openMenu">
                        <div class="columnSelectionAbsolute" >
                            <div>
                                <b-form-checkbox v-for="(col) in columns" :key="col.index" switch v-show="col.isdisplayed" v-model="col.show" @change="toggleColumn(col)" >
                                    <template v-if="col.label">{{$t(col.label)}}</template>
                                </b-form-checkbox>
                                <br>
                                <b-button :variant="getTheme.warning" style="width: 50%;" @click="openMenu=!openMenu">{{$t("g_Ok")}}</b-button>
                            </div>
                        </div>
                    </div>
                    <!--FIN - SELECTION DES COLONNES-->

                </div>


                <template slot="emptystate">
                    <div class="info-row">
                        <b-row class="justify-content-md-center">
                            <b-col cols="12" class="text-left">
                                <span>{{$t('g_NoData')}}</span>
                            </b-col>
                        </b-row>
                    </div>
                </template>

            </vue-good-table>
        </div>

    </div>
</template>

<script>
import mapGetter from '@/mixins/getters.js'
import moment from 'moment';
//import 'vue-good-table/dist/vue-good-table.css'
import './invoiceItemsGrid.css'
import { VueGoodTable } from 'vue-good-table';
import {dataService} from '@/services'

export default{
    name: 'itemGrid',
    mixins:[mapGetter],
    components: {
        VueGoodTable,
    },
    props: ['isSelectOptions','isAddItemBtn','labelAdd','columns','rows', 'searchTerm' ],
    data() {
        return {
            isLoading: true,
            openMenu: false,
            rowSelection: [],
            records : this.rows,
            isPagination : true,
            currrentFilterIndex : -1,
            searchTxt : '',
            resultList: [],
            filters : {},
            filteredRows: this.rows,
            selectedRows: []
        }
    },
    methods: {
        rowStyleClassFn(row) {
            return 'itemGridRow-'+row.id;
        },
        selectRow(params) 
        {

            // params.row - row object 
            // params.pageIndex - index of this row on the current page.
            // params.selected - if selection is enabled this argument 
            // indicates selected or not
            // params.event - click event
            if(!this.isSelectOptions)
            {
                let selectedRows = Array(1).fill(params.row)
                this.selectedRows = selectedRows;
                this.$emit('on-selection', {selectedRows: Array(1).fill(params.row)});
            }
            
        },
        onRowDoubleClick(params) 
        {
            // params.row - row object 
            // params.pageIndex - index of this row on the current page.
            // params.selected - if selection is enabled this argument 
            // indicates selected or not
            // params.event - click event
            this.$emit('on-row-dblclick', params);
        },
        selectCell(params) {
            // params.row - row object 
            // params.column - column object
            // params.rowIndex - index of this row on the current page.
            // params.event - click event
            this.$emit('on-cell-click', params);
        },
        onRowMouseover(params) {
            // params.row - row object 
            // params.pageIndex - index of this row on the current page.
            this.$emit('on-row-mouseenter', params);
        },
        onRowMouseleave(row, pageIndex) {
            // row - row object 
            // pageIndex - index of this row on the current page.

            this.$emit('on-row-mouseleave', {row:row, pageIndex:pageIndex});
        },
        showDate(inDate)
        {
            let date = moment(inDate);
            if(date.isValid() && !date.isSame(moment('1970-01-01 00:00:00')))
               return date.format("YYYY-MM-DD");
            return  ""
        },
        getMonetaryValue(value)
        {
            if(isNaN(value)){
                return this.$FM(Number(0),2);
            }
            return this.$FM(Number(value),2);
        },
        getQuantityValue(value)
        {
            if(isNaN(value)){
                return this.$FDouble(Number(0),2);
            }
            return this.$FDouble(Number(value),2);
        },
        selectionChanged(params) {
            this.rowSelection = params.selectedRows;
            this.selectedRows = params.selectedRows;
            this.$emit('on-multiple-selection', {selectedRows: params.selectedRows});
        },
        editRow(row, id) 
        {
            // row - row object 
            // pageIndex - index of this row on the current page.
            this.$emit('on-editRow', {row:row, pageIndex:id});
        },
        deleteRow(id) 
        {
            // pageIndex - index of this row on the current page.
            this.$emit('on-removeRow', {pageIndex:id});
        },
        addItem(){
            this.$emit('on-add-item');
        },
        toggleColumn(inColumn)
        {
            inColumn.hidden = !inColumn.hidden
        },
        enableMultipleSelection() {
            this.isSelectOptions = !this.isSelectOptions
        },
        enablePagination() {
            this.isPagination = !this.isPagination
        },
        clearFliter() {
            this.currrentFilterIndex = -1 
            this.resultList = []
            this.searchTxt = ''
            this.filteredRows = this.rows 
        },
        activateFilter(index, field) {
            this.filters = Object.assign(this.filters, { [field] : 0})
            this.currrentFilterIndex = index
            this.filterProduct(field)
        },
        applyFilter(item) {

            if(this.getFilters[this.currrentFilterIndex].field){
                let field = this.getFilters[this.currrentFilterIndex].field 
                var isLinkedColumn = this.getFilters[this.currrentFilterIndex].isLinkedColumn
                this.filters = Object.assign(this.filters, { [field] : item.id})

                var value = this.filters[field]

                var items = this.rows
                var filteredRows = this.rows.filter(item => {
                    if(item[field] && isLinkedColumn) {
                        return item[field].toString().includes(value.toString().toLowerCase())
                    } else return item
                });
                items = [...new Set(filteredRows)] 
                this.filteredRows = items 
            }
        },
        filterProduct(field) {
            this.resultList = []
            if(field == "departmentId") {
                this.isloading = true
                dataService.getDepartments()
                .then(response => {
                    if(response.statusText == 'OK')
                    {
                        let data = response.data.data;

                        data = data.map(elem => {
                            elem.label = elem['description1']
                            return elem
                        })


                        let resultList = this.$CObj(data)
                        var items = resultList
                        const search = this.searchTxt.toLowerCase().trim();
                        if (!search) items = resultList;
                        else {
                            var filteredItems = resultList.filter(item => {
                                var values = Object.values(item)
                                if(JSON.stringify(values.toString().toLowerCase()).indexOf(search) > -1) {
                                    return item
                                }
                            });
                            items = [...new Set(filteredItems)] 
                        }
                        this.resultList = items
                        this.isloading = false
                    }
                })
                .catch(error =>{
                    this.isloading = false
                    console.log(error);
                })
            }
            if(field == "categoryId") {
                this.isloading = true
                dataService.getCategories()
                .then(response => {
                    if(response.statusText == 'OK')
                    {
                        let data = response.data.data;

                        data = data.map(elem => {
                            elem.label = elem['categoryName']
                            return elem
                        })

                        let resultList = this.$CObj(data)
                        var items = resultList
                        const search = this.searchTxt.toLowerCase().trim();
                        if (!search) items = resultList;
                        else {
                            var filteredItems = resultList.filter(item => {
                                var values = Object.values(item)
                                if(JSON.stringify(values.toString().toLowerCase()).indexOf(search) > -1) {
                                    return item
                                }
                            });
                            items = [...new Set(filteredItems)] 
                        }
                        this.resultList = items
                        this.isloading = false
                    }
                })
                .catch(error =>{
                    this.isloading = false
                    console.log(error);
                })
            }
        }
        
    },
    computed: {
        getFilters(){
            
            let filters = [
                {
                    field: 'departmentId',
                    isLinkedColumn : true,
                    labelName: 'modal_ItemDepartmentId'
                },
                {
                    field: 'categoryId',
                    isLinkedColumn : false,
                    labelName: 'modal_CategoryId',
                },
                
            ]
            
            //Ajouter la traduction dans l'attribut label
            filters.map(elem => {
                elem.label = (elem.labelName) ? this.$i18n.t(elem.labelName) : elem.field;
                return elem
            })

            return filters
        },
        selectedIds() {
            if(this.selectedRows?.length > 0 ) return this.selectedRows?.map((r) => r.id )
            else return []
        },
    },
    mounted() {
        
    },
    watch: {
        // rows: function(newValue) {
        //     this.records = newValue
        // },
    },
}
</script>

<style lang="scss" scoped>

    .info-row {
        background: transparent;
        padding: 5px 16px;
        font-size: 13px;
        color: #d3aa3b;
        font-weight: 700;
    }

    .columnSelectionRelative {
        position: relative;
        z-index: 999;
        margin-right: 2px;
        top:-4px;
    }

    .columnSelectionAbsolute {
        position: absolute;
        top:0;
        right:0;
        animation: fadeIn 0.4s;
        -webkit-animation: fadeIn 0.4s;
        -moz-animation: fadeIn 0.4s;
        -o-animation: fadeIn 0.4s;
        -ms-animation: fadeIn 0.4s;
        text-align: left;
        padding-left: 10px;
        padding-right: 50px;
        padding-top: 10px;
        padding-bottom: 10px;
        border: 1px $ServexBlue solid;
        border-radius: 2px;
        box-shadow: 2px 2px 4px $ServexShadow;
        z-index: 999;
        width: fit-content;
        height: fit-content;
        background: $ServexWhite;
    }
    .filter {
        background-color: #e3e6ea;
        border-color: #e3e6ea;
    }

    .filter:hover {
        background-color: #d1d4d7;
        border-color: #d1d4d7;
    }
</style>